import React from 'react';
import { Modal } from 'reactstrap';
import _ from 'lodash';
import classnames from 'classnames';

import { Form, FormActionsBtns, Intl } from 'components';

export default React.memo(({
  title, open, onClose, children, body, isLoading, size = 'lg', bodyClassName, bodyStyle, footer, formEnabled = true,
  translateTitle = true, values, name, ...rest
}) => (
  <Modal
    className="modal-dialog-centered app-modal"
    size={size}
    isOpen={open}
    toggle={onClose}
    zIndex={5000}
    backdrop="static"
    contentClassName={classnames({
      'app-component-loading': isLoading,
    })}
  >
    <div className="modal-header">
      {!!title
        && (
          <span className="modal-title font-weight-bold text-gray-7">
            {translateTitle ? <Intl id={title} values={{ name: values && values.length > 44 ? `${values.slice(0, 42)}...` : values }} /> : title}
          </span>
        )}
      <button
        aria-label="Close"
        className="close text-sm"
        data-dismiss="modal"
        type="button"
        onClick={onClose}
      >
        <i className="fa fa-times" />
      </button>
    </div>
    <Form
      {...rest}
      body={(form) => (
        <div
          className={classnames('modal-body py-0', bodyClassName)}
          style={bodyStyle}
        >
          {children || (body && _.isFunction(body) ? body(form) : body)}
        </div>
      )}
      footer={(
        <div className="modal-footer justify-content-center">
          {formEnabled
            ? footer || <FormActionsBtns onClickCancel={onClose} marginContainer={false} /> : null}
        </div>
      )}
    />
  </Modal>
));
